import { CIMSTabs } from 'components/CIMSTabs'
import NotificationsTab from './components/Notifications'
import TemplatesTab from './components/Templates'

const Tab = { Notifications: 'Notifications', Templates: 'Templates' } as const

function Notifications() {
  return (
    <CIMSTabs
      initialTab={Tab.Notifications}
      tabs={[
        {
          label: Tab.Notifications,
          key: Tab.Notifications,
          component: <NotificationsTab />,
        },
        {
          label: Tab.Templates,
          key: Tab.Templates,
          component: <TemplatesTab />,
        },
      ]}
    />
  )
}

export default Notifications
